import { DataConnector } from "@/api/data-connectors";
import { Card } from "@/design-system/components/Card";

import { ApiHelperCard } from "./ApiExamplesCard";

interface Props {
  dataConnector: DataConnector;
}

export function DataConnectorHelperCard({ dataConnector }: Props) {
  switch (dataConnector.type) {
    case "api": {
      return <ApiHelperCard dataConnector={dataConnector} />;
    }
    case "airbyte": {
      return <Card />;
    }
  }
}
